import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import eventData from "../data/eventData";
export default function Events() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = eventData.map((el, index) => (
        <div key={index} className="w-100 w-[31%] flex flex-col gap-[15px] bg-white rounded-[4px]">
            <div className="w-full h-[250px]">
                <img className="w-full h-full rounded-t-[4px]" src={el.mainImage} alt="" />
            </div>
            <div className="p-[10px] h-[150px] flex flex-col gap-[10px] justify-between">
                <div className="text-[#016e82] font-bold">{el.title}</div>
                <Link className="bg-[#016e82] text-center font-bold text-white p-2 rounded-[4px]" to={`/event-images/${el.id}`}>{t("Show Images")}</Link>
            </div>
        </div>
    ))

    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white  capitalize">{t("Events")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Events")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-wrap gap-[20px]">
                    {showData}
                </div>
            </section>
        </>
    );
}